import { useEffect } from 'react';
import { useStore } from 'react-redux';

import { actionClearStagedPicks } from 'lib/actions';
import { getStagedPicksByWoo } from 'lib/selectors/getPicking';
import { getStagedPicksToWrite } from 'lib/selectors/getStagedPicksToWrite';
import { throwErrorToast } from 'lib/utils/toast';

/**
 * Drops the picks staged for `wooId` when the job start flow unmounts (or moves to
 * another WOO) without a confirmed start: leaving by app navigation, sign-out or
 * closing activity selection. Without this, a later start of the WOO would write
 * them. A successful start navigates away only after the server confirms it, so
 * staged picks that are ready to write by then are kept for StagedPicksFlusher.
 *
 * Mounted by the start flow (MultiStep) rather than the pick step, which unmounts
 * when work order flow moves on to its own activity step.
 */
const useDiscardAbandonedStagedPicks = (wooId, enabled) => {
  const store = useStore();

  useEffect(() => {
    if (!enabled || wooId == null) return undefined;
    return () => {
      const state = store.getState();
      if (!getStagedPicksByWoo(state)[String(wooId)]) return;
      const toWrite = getStagedPicksToWrite(state);
      if (String(toWrite?.workOrderOperationRef) === String(wooId)) return;
      store.dispatch(actionClearStagedPicks(wooId));
      throwErrorToast(
        'Material picks were not recorded because the job did not start.'
      );
    };
  }, [enabled, wooId, store]);
};

export default useDiscardAbandonedStagedPicks;
